const awardImagesByYear = {
  2025: [
    "images/Awards/Gold2025-new.png",
    "images/Awards/Silver2025-new.png",
    "images/Awards/Bronze2025-new.png",
  ],
  2024: [
    "images/Awards/Gold2024-new.png",
    "images/Awards/Silver2024-new.png",
    "images/Awards/Bronze2024-new.png",
  ],
  2023: [
    "images/Awards/Gold2023.png",
    "images/Awards/Silver2023.png",
    "images/Awards/Bronze2023.png",
  ],
  2022: [
    "images/Awards/Silver-2022-new.png",
    "images/Awards/Bronze-2022-new.png",
    "images/Awards/Best-atd-new.png",
  ],
  2021: [
    "images/Awards/silver-2021-new.png",
    "images/Awards/gold-2021-new.png",
    "images/Awards/Best-atd-new.png",
  ],
  2020: [
    "images/Awards/Silver-Learning-Award-2020.png",
    "images/Awards/Gold-Learning-Award-2020.png",
    "images/Awards/Best-atd-new.png",
  ],
  2019: [
    "images/Awards/Gold-Learning-Award-2019.png",
    "images/Awards/Bronze-Learning-Award-2019.png",
  ],
  2018: [
    "images/Awards/Silver-Learning-Award-2018.png",
    "images/Awards/accenture-logo-new.png",
    "images/Awards/world-hrd-award.png",
  ],
  2017: [
    "images/Awards/Silver-Learning-Award-2017.png",
    "images/Awards/TISS-leapvault.png",
  ],
};

export default awardImagesByYear;
